import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default (status, message) => {
  if (status === 200) {
    toast.success(message, { style: { background: "#51a351" } });
  } else {
    toast.error(message, { style: { background: "#bd362f" } });
  }
};
